<template>
  <div class="app-current-tariff">
    <CouponInsertCodeModalContract
      :show.sync="showCouponInsertCodeModal"
      :redeemed.sync="promoCodeRedeemed"
      :showModal.sync="showCouponInsertCodeModal"
      :promoID.sync="validatedPromoId"
      :manualInsert.sync="manualInsertedCode"
    >
      <template slot="txtCouponInsertModalTitle"><slot name="txtCouponInsertModalTitle"></slot></template>
      <template slot="txtCouponRedeemModalTitle"><slot name="txtCouponRedeemModalTitle"></slot></template>
      <template v-for="slot in possibleChildSlotsFor('Contract')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </CouponInsertCodeModalContract>
    <TariffOptionCancelModal v-if="hasCancelableAboOption"
                             :option="activeCancelModalOption"
                             ref="cancelModal"
                             :gotBackendErrorInitiate.sync="gotBackendErrorCancel"
    >
      <template v-for="slot in possibleChildSlotsFor('CancelModal')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
      <template v-for="optionSlot in possibleChildSlotsFor('TariffOptions', activeCancelModalOption.tariffoptionId)" v-slot:[`${optionSlot.child}`]>
        <slot :name="`${optionSlot.parent}`"></slot>
      </template>
    </TariffOptionCancelModal>
    <SimonModal
      :is-visible="showCouponInfoModal"
      @hide="showCouponInfoModal = false"
      id="coupon-info-modal"
    >
      <slot v-if="modalType === 'couponBreak'" name="txtCouponBreakModal">Vertragspause</slot>
      <slot v-else-if="modalType === 'couponDismissal'" name="txtCouponDismissalModal">Vertragskündigung</slot>
    </SimonModal>
    <div v-show="isReady && !this.contractTerminated">
      <div class="card card-current-tariff">
        <slot name="txtBefore"></slot>
        <div class="tariff-head">
          <div class="tariff-name-wrapper" v-if="tariffs.bookedTariff !== null && tariffs.bookedTariff.name">
            <div class="tariff-name">
              <slot name="txtTariffPrefix">Dein Tarif<br></slot>
              <h2>{{ tariffs.bookedTariff.name }}</h2>
            </div>
          </div>
          <slot name="txtAfterName"></slot>
        </div>
        <div class="current-tariff-headline">
          <slot name="txtTarifDetailsHeadline"><Vertragsdetails class="."></Vertragsdetails></slot>
        </div>
        <table class="tariffs-details-wrapper selfservice"><tbody>
        <tr v-for="volume in bookedTariffVolumes" :key="volume.type" class="row tariff-detail-row">
          <td class="text tariff-detail-text contract">{{ volumenDescription(volume) }}</td>
          <td class="value tariff-detail-value">{{ volume.amount }} {{ volume.formattedUnit }}</td>
        </tr>
        <tr class="row tariff-detail-row" v-if="tariffs.bookedTariff !== null && tariffs.bookedTariff.formattedBasicFee">
          <td class="text tariff-detail-text contract">
            <slot name="txtPriceText">Monatlicher Basispreis</slot>
          </td>
          <td class="value tariff-detail-value">{{ price(basicFeeWithOptions) }}</td>
        </tr>
        <PromoCurrentTariffDiscount v-for="incentive in creditIncentivesForCurrentTariff"
                                    :key="incentive.incentiveId"
                                    :promoId="incentive.promotionId"
                                    :description="incentive.description"
                                    :discount="incentive.discount"
                                    :expirationDate="incentive.expirationDate"
                                    :isPromoCode="incentive.isPromoCode"
                                    context="REGISTER_MEMBER"
                                    :default=false
        >
          <template v-for="slot in possibleChildSlotsFor('Contract')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </PromoCurrentTariffDiscount>
        <PromoCurrentTariffAddedVolume v-for="incentive in volumeIncentivesForCurrentTariff"
                                       :key="incentive.id"
                                       :promoId="incentive.promotionId"
                                       :description="incentive.description"
                                       :amount="incentive.amount"
                                       :unit="incentive.unit"
                                       :expirationDate="incentive.expirationDate"
                                       :isPromoCode="incentive.isPromoCode"
                                       context="REGISTER_MEMBER"
                                       :default=false
        >
          <template v-for="slot in possibleChildSlotsFor('Contract')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </PromoCurrentTariffAddedVolume>
        <tr v-for="option in activeBookedTariffOptions" :key="option.tariffoptionId" class="row tariff-detail-row">
          <td class="text tariff-detail-text contract">
            <slot name="lblOptionPrefixText"></slot>
            {{ option.name }}
            <img v-if="aboOptionCancelable(option)" src="files/flash/images/svg-icons/trashbin.svg" class="cancelTrashIcon" alt="" @click="openCancelTariffOptionModal(option)">
            <div class="subtext tariff-detail-subtext">
              <span v-if="aboOptionCancelable(option)"><slot name="txtExtendsOn">verlängert sich am</slot></span>
              <span v-else-if="showEndOfRuntime(option)"><slot name="txtValidUntil">gültig bis</slot></span>
              <span v-if="showEndOfRuntime(option) && option.expirationDate === null">&nbsp;{{ dateFormatter(new Date(option.activeRuntime.endOfRuntime)) }}</span>
              <span v-else-if="showEndOfRuntime(option) && option.expirationDate !== null">&nbsp;{{ dateFormatter(new Date(option.expirationDate)) }}</span>
            </div>
          </td>
          <td class="value tariff-detail-value">
            <div class="tariff-detail-volume">
            <span v-for="volume in option.volumes" :key="volume.type">
              {{ volume.amount }} {{ volume.formattedUnit }}
            </span>
            </div>
          </td>
        </tr>
        </tbody></table>
        <div v-if="gotBackendError || gotBackendErrorCancel" v-html="this.beErrorGetLastMessage()" class="error-box"></div>
        <!-- Disable coupon insert button in serlfservice contract area -->
        <!--
        <div v-if="this.contractPauseActive || this.hasPendingDismissal || this.contractPauseCreated" class="current-tariff-coupon-link">
          <div class="b-overlay-wrap position-relative btn-next-overlay coupon-code-payment-button">
            <button class="text" disabled="disabled">Gutschein einlösen</button>
            <span v-if="this.contractPauseActive || this.contractPauseCreated"><a class="info-link-icon" @click="showCouponInfoModal=true; modalType='couponBreak'"></a></span>
            <span v-else-if="this.hasPendingDismissal"><a class="info-link-icon" @click="showCouponInfoModal=true; modalType='couponDismissal'"></a></span>
          </div>
        </div>
        <div v-else class="current-tariff-coupon-link">
          <div class="b-overlay-wrap position-relative btn-next-overlay coupon-code-payment-button">
            <button class="text" @click="openCouponInsertCodeModal"><slot name="btnNextRedeem">Gutschein einlösen</slot></button>
          </div>
        </div>
        -->
        <slot name="txtAfter"></slot>
      </div>
    </div>
    <div v-if="showError" v-html="this.errorMsg" class="error-box"></div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import extraData from '@/mixins/extraData'
import { mapActions, mapGetters } from 'vuex'
import debounce from 'lodash.debounce'
import { splitError } from '@/helper/splitError'

import price from '@/mixins/formatters/price'
import dateFormatter from '@/mixins/formatters/dateFormatter'
import beErrors from '@/mixins/beErrors'
import customerContractState from '@/mixins/customerContractState'
import PromoCurrentTariffDiscount from '@/components/generic/Promotions/CurrentTariffDiscount.vue'
import PromoCurrentTariffAddedVolume from '@/components/generic/Promotions/CurrentTariffAddedVolume.vue'
import CouponInsertCodeModalContract from '@/components/modal/coupon/CouponInsertCodeModalContract.vue'
import TariffOptionCancelModal from '@/components/process/generic/Tariff/TariffOptionCancelModal.vue'
import promoContext from '@/mixins/promoContext'
import SimonModal from '@/components/modal/SimonModal.vue'

export default {
  name: 'CurrentTariff',
  components: {
    SimonModal,
    PromoCurrentTariffDiscount,
    PromoCurrentTariffAddedVolume,
    CouponInsertCodeModalContract,
    TariffOptionCancelModal
  },
  data () {
    return {
      tariffs: {
        bookedTariff: null
      },
      tariffoptions: {
        bookedTariffoptions: null
      },
      showError: false,
      errorMsg: {
      },
      gotBackendError: false,
      gotBackendErrorCancel: false,
      showCouponInsertCodeModal: false,
      showCouponRedeemedModal: false,
      promoCodeRedeemed: false,
      showCouponInfoModal: false,
      modalType: '',
      validatedPromoId: null,
      manualInsertedCode: true,
      couponRedeemedModalInfo: '',
      cancelOption: null
    }
  },
  mounted () {
    this.startLoader()
  },
  // debounce function from https://stackoverflow.com/a/46187226
  updated: debounce(function () {
    this.$nextTick(() => {
      if (window.location.hash) {
        const el = document.querySelector(window.location.hash)
        if (el) {
          el.scrollIntoView()
        }
      }
    })
  }, 1000),
  methods: {
    ...mapActions('bookTariff', [
      'initiateCancelTariff'
    ]),
    ...mapActions('promotion/activePromotions', [
      'getActivePromotions'
    ]),
    ...mapActions('promotion/promoCode', [
      'getSlotsIdForVoucherPromo'
    ]),
    volumenDescription (volume) {
      switch (volume.type) {
        case 'data':
          return this.getSlotText('txtLabelDataVolumeCurrentTariff', 'Verfügbares Datenvolumen')
        default:
          return volume.type
      }
    },
    openCouponInsertCodeModal () {
      this.showCouponInsertCodeModal = true
      const data = {
        information_action: 'reveal',
        information_name: 'gutschein einlosen',
        information_ui_type: 'overlay',
        information_trigger: 'link'
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('information', data)
      }
    },
    openCancelTariffOptionModal (option) {
      this.cancelOption = option
      const _this = this
      this.$nextTick(() => {
        _this.$refs.cancelModal.initializeCancelOption()
      })
    },
    aboOptionCancelable (option) {
      return option.automaticExtension && option.statusKey === 'CDL' && !this.contractDismissedInFuture
    },
    showEndOfRuntime (option) {
      return !option.automaticExtension || (option.automaticExtension && ['CAN', 'TER'].includes(option.statusKey)) || !this.contractDismissedInFuture
    }
  },
  computed: {
    bookedTariffOptions () {
      return this.tariffoptions.bookedTariffoptions?.bookedTariffoptions || []
    },
    bookedTariffVolumes () {
      return this.tariffs?.bookedTariff?.volumes || []
    },
    isReady () {
      return !this.$apollo.queries.tariffs.loading && this.tariffs.bookedTariff !== null && this.tariffoptions.bookedTariffoptions !== null && this.loadedContractState
    },
    hasCancelableAboOption () {
      return this.bookedTariffOptions.find((option) => option.automaticExtension)
    },
    activeCancelModalOption () {
      if (this.cancelOption !== null) {
        return this.cancelOption
      } else {
        return this.hasCancelableAboOption
      }
    },
    activeBookedTariffOptions () {
      return this.bookedTariffOptions.filter((option) => {
        return ['CDL', 'CAN', 'TER'].includes(option.statusKey)
      })
    },
    ...mapGetters('promotion/activePromotions', [
      'activePromotions',
      'volumeIncentives',
      'volumeIncentivesForCurrentTariff',
      'creditIncentivesForCurrentTariff'
    ]),
    showAmountCondition () {
      return this.showAmount && this.showFeaturePromotion
    },
    basicFeeWithOptions () {
      let fee = this.tariffs.bookedTariff.basicFee
      if (this.tariffoptions?.bookedTariffoptions?.bookedTariffoptions) {
        this.tariffoptions?.bookedTariffoptions?.bookedTariffoptions.forEach((option) => {
          if (option.automaticExtension && ['CDL', 'CAN', 'TER'].includes(option.statusKey)) {
            fee += option.price
          }
        })
      }
      return fee
    }
  },
  mixins: [
    extraData(),

    price,
    dateFormatter,
    customerContractState(),
    promoContext,
    beErrors
  ],
  props: {
    tariffPageLink: {
      type: String,
      default: null
    }
  },
  apollo: {
    tariffs: function () {
      return wrapQuery(
        gql`query bookedTariff {
          tariffoptions{
            bookedTariffoptions {
              bookedTariffoptions {
                automaticExtension
                tariffoptionId
                name
                details
                price
                formattedPrice
                statusKey
                revocable
                expirationDate
                activeRuntime {
                  endOfRuntime
                  startOfRuntime
                }
                duration {
                  amount
                  unit
                  formattedUnit
                }
                volumes {
                  formattedUnit
                  type
                  amount
                  unit
                }
              }
            }
          }
          tariffs{
            bookedTariff {
              tariffState
              name
              basicFee formattedBasicFee
              terminationDate
              renewContractDate
              contractPeriod
              changeTariffDate
              volumes {
                formattedUnit
                type
                amount
                unit
              }
            }
          },
        }`, this, ['tariffs', 'tariffoptions'], {}, () => {
          this.showError = false
          this.stopLoader()
        },
        {
          fetchPolicy: 'cache-first'
        },
        (error) => {
          splitError(error).forEach(e => {
            this.errorMsg = e.message
          })
          if (!this.showError) {
            const data = {
              type: 'technical',
              message: this.errorMsg
            }
            if (typeof window.trackingNS?.track?.tracking === 'function') {
              window.trackingNS.track.tracking('error', data)
            }
          }
          this.showError = true
          this.stopLoader()
        }
      )
    }
  }
}
</script>
